export enum DepositType {
  D_0_00 = '0.00',
  D_0_05 = '0.05',
  D_0_08 = '0.08',
  D_0_10 = '0.10',
  D_0_15 = '0.15',
  D_0_25 = '0.25',
  D_0_28 = '0.28',
  D_0_50 = '0.5',
  D_1_50 = '1.5',
  D_8_00 = '8.00',
  D_9_75 = '9.75',
  D_10_00 = '10.00',
}
